import classNames from "classnames";
import { PropsWithChildren } from "react";

export interface InputWrapperProps {
  /** Use "large" for the sign up form and marketing site,
   * "right" for radio buttons and checkboxes,
   * and the default size for everything else. */
  inputType?: "default" | "large" | "left";
  /** The default width is set to match the inputs size to its content.
   * Full width sets the input to have a width of 100% of its parent element. */
  inputWidth?: "default" | "full";
  /** Optional helper text for an input */
  helperText?: string;
  /** Visually the same as helper text but rendered separately to allow for both to be
   * present at the same time. */
  errorText?: string;
  /** Move input alignment to the right for displaying things like currency */
  alignment?: "left" | "right";
  /** Signify if input is disabled or not */
  disabled?: boolean;
}

export const InputWrapper: React.FC<PropsWithChildren<InputWrapperProps>> = ({
  inputType = "default",
  inputWidth,
  disabled,
  helperText,
  errorText,
  children,
  alignment,
}) => {
  const wrapperClasses = classNames("input", {
    [`input--${inputType}`]: inputType,
    [`input--error`]: errorText,
    ["input--disabled"]: disabled,
    [`input--full-width`]: inputWidth === "full",
  });

  return (
    <div className={wrapperClasses} data-align={alignment}>
      {children}
      {helperText && <p className="input__helper">{helperText}</p>}
      {errorText && (
        <p className="input__helper input__helper--error">{errorText}</p>
      )}
    </div>
  );
};
